import React from 'react';
import LineagesHeroRo from '../../components/lineages/ro/LineagesHeroRo';
import LineagesIntroRo from '../../components/lineages/ro/LineagesIntroRo';
import FamilyVasquezRo from '../../components/lineages/ro/FamilyVasquezRo';
import FamilyTanakaRo from '../../components/lineages/ro/FamilyTanakaRo';
import FamilyOseiRo from '../../components/lineages/ro/FamilyOseiRo';
import FamilyRiveraRo from '../../components/lineages/ro/FamilyRiveraRo';
import LineagesCtaRo from '../../components/lineages/ro/LineagesCtaRo';

const LineagesPageRo = () => (
  <main>
    <LineagesHeroRo />
    <LineagesIntroRo />
    <FamilyVasquezRo />
    <FamilyTanakaRo />
    <FamilyOseiRo />
    <FamilyRiveraRo />
    <LineagesCtaRo />
  </main>
);

export default LineagesPageRo;